import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M150 1400V150h2500v2500H150zm2435 0V215H215l-3 1175c-1 646 0 1181 3 1188 3 10 246 12 1187 10l1183-3z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.184 1029.953)" /><path d="M250 1400V250h2300v2300H250zm2260 0V290H290v2220h2220z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.18 1029.956)" /><path d="M1202 2425c-114-57-212-134-212-167 0-12 18-4 66 28 78 52 216 121 262 130 27 6 32 4 32-13 0-15-16-27-66-48-131-56-250-148-287-223-58-114-7-189 208-306 120-65 132-76 107-99-41-37-193-87-262-87-81 1-95 39-120 340-23 268-49 442-67 447-19 7-37-68-36-152 1-44 9-132 18-195s22-201 29-306c10-148 16-196 29-214 9-14 17-41 17-60 0-55 28-137 53-155 49-34 189-9 305 56l53 30 30-26c39-32 65-32 120 4 40 25 48 27 64 15 28-21 58-17 100 12 33 22 40 23 52 11 13-12 8-32-35-148-28-74-52-143-54-154-2-14-15-23-42-30-55-13-88 7-101 63-7 32-13 42-25 39-294-88-390-106-458-87-58 15-74 52-118 262-35 171-69 306-79 316-9 10-35-67-35-105 0-21 11-83 25-137s25-125 25-158c0-58-1-61-54-117-69-71-167-131-217-131-68 0-85 54-54 170 18 68 18 68 0 44-25-33-55-144-55-206 0-73 22-123 59-136 35-12 109 1 170 30 50 24 155 124 166 157 9 30 22 26 30-10 9-42 67-97 111-105 49-9 187 1 254 19 30 9 57 14 59 12s-8-18-23-35c-14-17-26-35-25-38 0-4 16-20 36-37l35-29 24 27c32 37 31 70-3 96-14 12-24 23-22 25 4 4 113 36 122 36 3 0 8-12 12-27 12-49 33-63 95-63h57l6-45c11-80 59-125 131-125 50 0 68 38 74 152l4 88 42 11c22 5 57 14 76 20 72 19 74 12 28-87-18-38-51-118-73-179-40-107-42-110-74-113-37-4-61 12-61 39 0 17-5 15-42-11-59-43-103-36-124 18-1 1-27-11-59-28-61-32-94-37-113-18-20 20-14 68 13 100 35 42 33 81-7 109l-31 23-37-43-37-42-16 25c-25 37-56 43-79 15-40-51-40-54 7-87l45-31 22 29c27 37 39 37 75 5l28-25-30-25c-68-57-171-89-213-66-32 17-51 62-58 133-4 35-14 71-22 81-51 59-193-38-237-162-19-54-22-136-5-155 7-9 29-19 50-22 47-8 68-20 55-32-37-34-239-92-323-92-46 0-58 4-82 28-59 60-62 162-10 327l29 90-24-28c-53-61-103-293-86-399 12-70 21-88 63-123 31-26 36-27 113-22 203 13 435 159 435 273 0 29-48 63-119 84-39 11-71 26-71 32s20 30 44 54c37 37 49 44 83 44h40l7-65c8-77 20-112 48-142 43-46 134-39 222 18l44 27 12-29c8-18 23-32 39-36 33-9 47-6 92 17 35 17 36 17 47-1 16-25 60-24 116 3 44 21 46 21 65 4 11-10 38-20 61-23l42-6-6-39c-15-90 34-158 114-158 86 0 126 62 118 181l-5 69 31 4c157 24 213 38 255 63 75 47 109 130 95 235l-7 51-29-32c-25-28-29-40-27-82 3-59 1-61-91-89-61-19-260-53-267-46-2 1 2 17 8 35 7 20 10 72 7 135l-5 102 33-4c18-2 51 5 77 16 44 19 45 19 61 1 20-24 43-24 84 1 100 61 131 165 90 303-6 20-14 37-18 37s-15-18-25-39c-17-38-17-52 1-139 6-29 4-33-27-46-39-16-55-12-62 16-5 19-7 19-50-6-49-29-108-34-127-11-6 8-14 33-17 55-4 26-10 39-18 37-34-14-174-55-202-60-37-7-37-9-23 62 6 35 6 76 0 124-10 70-10 71 16 95 14 14 32 40 40 58 15 35 18 165 5 199-4 11-3 34 2 51 8 27 5 43-19 98l-28 66-15-28c-24-44-20-164 8-249 19-59 21-76 11-88-18-22-47-18-67 9l-18 24-33-29c-40-36-50-36-62-4l-10 25-37-23c-92-58-145-59-151-3-2 14-5 26-6 26-2 0-36-15-77-34-122-56-208-81-278-81-49 0-66 4-74 17-6 9-8 20-5 24 4 3 45 10 91 15 105 11 188 41 239 87 48 44 67 79 78 145 15 95-16 129-195 220-87 44-155 93-155 111 0 70 493 299 582 270 17-5 19-12 15-43-3-20-9-47-13-60-12-42 16-13 42 43 37 80 29 137-23 157-23 9-89-5-235-48-13-4-17 3-20 34-3 34-6 38-33 41-20 2-67-15-143-53m529-1142c14-38 2-79-33-108-26-22-58-33-58-20 0 7 49 134 55 146 11 17 25 9 36-18m-27-284c14-11 33-34 41-50l16-29h-33c-45 0-80 20-97 54-11 24-11 30 0 37 22 14 45 10 73-12m250-115c10-27 7-74-8-103-12-22-52-51-72-51-8 0 8 54 34 113s36 68 46 41m-50-318c31-13 76-59 76-77 0-5-13-9-29-9-34 0-76 31-96 71-14 26-14 29 0 29 9 0 30-6 49-14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.175 1029.959)" /><path d="M1879 2425c-22-46-24-61-23-195 0-116 7-180 32-324 18-99 37-230 43-293 7-62 16-110 20-107 17 10 39 109 39 173 0 36-12 133-26 214-22 124-25 156-15 187 16 53 14 111-5 156-9 22-22 84-29 139l-12 100z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.125 1029.959)" /><path d="M2133 2358c-11-13-29-36-39-52-18-29-18-29 1-40 11-6 33-24 49-40l30-28 23 28c45 55 37 100-23 141-18 11-23 10-41-9" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.118 1029.962)" /><path d="M601 2273c-17-21-31-42-31-48 0-5 16-23 35-38s35-33 35-40c-1-7-14-28-30-47-17-19-30-39-29-45 0-5 20-27 44-48l42-37 27 38c14 21 26 43 26 50 0 6-14 27-31 46l-30 35 25 38c14 21 26 43 26 50 0 14-58 83-70 83-5 0-22-17-39-37" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.17 1029.964)" /><path d="m1687 2215-38-45 46-43 46-44 29 34c39 44 38 71-3 111-18 18-35 32-38 32s-22-20-42-45" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.132 1029.966)" /><path d="m2207 2210-35-41-30 31c-17 16-35 30-41 30-10 0-71-69-71-81 0-7 80-89 86-89 3 0 18 21 34 46l29 47 38-38 37-37 28 31c41 46 37 77-18 124-21 18-22 17-57-23" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.12 1029.966)" /><path d="M1517 2160c-24-28-43-69-35-73 1-1 22-17 46-36 24-18 44-31 46-30 1 2 12 17 24 33 29 38 28 68-4 105-32 39-46 39-77 1" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.138 1029.968)" /><path d="M1620 2053c0-5-12-21-26-36l-24-29-36 32-36 31-30-28c-52-50-53-58-6-102l43-40 24 22c13 12 27 33 33 47l9 25 36-39c40-44 55-42 86 12 17 28 17 33 2 61-19 38-74 69-75 44" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.14 1029.973)" /><path d="M2044 2018c-12-38-6-88 15-122 25-40 115-125 199-189 34-27 62-55 62-64 0-56-273-213-369-213-49 0-66 43-52 130 7 46 7 51-5 36-14-20-32-101-35-156-3-75 2-101 21-120 99-99 520 190 520 358 0 39-39 85-126 149-38 28-64 54-64 65 0 10-10 26-22 36-12 9-45 38-73 65-29 26-55 47-58 47s-9-10-13-22" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.125 1029.974)" /><path d="M390 1800c0-31 28-110 39-110 3 0 25-17 48-38l42-37-19-70c-26-96-26-169 0-195 25-25 53-25 107-1 60 28 94 83 100 165l6 65-59 61-59 62 23 38c12 22 22 44 22 49 0 24-21 8-45-33l-26-45-77 60c-42 32-83 59-89 59-8 0-13-13-13-30m212-247c53-56 63-80 39-93-27-14-84-13-99 2-22 22-12 128 12 128 7 0 28-17 48-37" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.175 1029.98)" /><path d="M2208 488c-41-56-41-56 3-98 34-32 45-38 56-28 16 13 43 62 43 77 0 13-59 81-70 81-4 0-19-15-32-32" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.114 1030.025)" /><path d="m1149 461-31-39-30 34c-17 19-36 34-43 34s-28-18-45-40l-32-40 45-44 46-44 27 39c15 21 32 39 39 39s27-16 44-35 33-35 35-35c6 0 56 84 56 93 0 10-61 77-71 77-4 0-22-18-40-39" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.156 1030.026)" /><path d="M1307 488c-2-7 4-30 14-50 11-21 19-45 19-55s5-25 11-33c8-11 9-1 6 40-7 79-36 136-50 98" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.144 1030.026)" /><path d="M1404 487c-3-8 2-29 11-47 9-17 20-50 25-73l8-42 1 58c1 56 5 62 39 58 8-1 20 3 29 10 18 16 28 3 44-56 16-63 17-63 18-7 1 34 5 52 14 53 6 1 21 2 32 3 13 0 21 9 23 25 3 16 0 21-8 16-7-4-16-1-21 6-7 11-11 10-23-6-13-18-16-18-33-4-20 17-31 18-52 5-10-6-16-5-19 3-3 9-9 8-23-5-18-16-20-16-39 1-17 16-20 16-26 2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.14 1030.026)" /><path d="M1696 448c-9-31-21-60-26-63-6-3-10-15-10-26 0-30 18-13 37 32l16 40 17-39c10-22 23-42 28-46 22-13 21 14-2 61-13 26-28 59-33 73-9 23-11 21-27-32" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.3824 0 0 -.3824 -32.132 1030.026)" /></svg>;
export default Component;
export { Component as ReactComponent };